export default {
  common: {
    back: '戻る',
    cancel: 'キャンセル',
    noBooking: '予約情報が見つかりません',
    openFromBooking: '予約詳細からもう一度お進みください。',
    loadFailed: '読み込みに失敗しました',
    retry: '再試行'
  },
  views: {
    change: {
      policy:
        '変更ポリシー：同じ乗車日の列車に限り、元の列車の発車前かつ空席がある場合に変更できます。複数回変更可能です。乗降駅と人数は変更できません。',
      confirmSelect: '変更を確定',
      submittedTitle: '予約を変更しました',
      submittedThanks: 'ホームに戻り、更新されたチケットをご確認ください。'
    },
    trainList: {
      vehicleInfo: '列車情報',
      ticketName: '小田急ロマンスカー',
      travelDate: '利用日：',
      route: '出発・到着：',
      ticketCount: '予約数：',
      trainType: '車種：',
      seatClass: '座席タイプ：',
      preference: '座席の希望：',
      preOrderNote: '',
      selectStation: '駅を選択',
      from: '出発',
      to: '到着',
      swap: '出発駅と到着駅を入れ替える',
      selectTrain: '列車を選択',
      select: '選択',
      book: '予約',
      seatAvailable: '空席あり',
      seatLimited: '残りわずか',
      soldOut: '満席',
      notOnSale: '発売前',
      noTimeRanges: '利用可能な時間帯がありません',
      noTrains: 'この時間帯に列車はありません'
    },
    seat: {
      title: '座席を選択してください',
      ticketCount: '予約数：',
      selectMethod: '座席指定方法',
      selectByPreference: '条件から指定',
      selectBySeatMap: '座席表から指定',
      preference: '位置の希望',
      car: '号車',
      noCarPreference: '指定なし',
      selectSeats: '座席を選択（{{selected}}/{{total}}）',
      seatLabel: '座席 {{seat}}',
      seatMapDescription:
        '※A/D席は窓側、B/C席は通路側です。号車をまたいだ座席指定はできません。',
      noSeats: 'この号車には選択できる座席がありません',
      noTrain: '列車が選択されていません',
      selectTrainFirst: '戻って列車を選択してください。',
      next: '次へ'
    },
    confirm: {
      trainConfirm: '列車の確認',
      ticketName: '小田急ロマンスカー',
      route: '出発・到着：',
      travelDate: '利用日：',
      ticketCount: '予約数：',
      trainType: '車種：',
      seatClass: '座席タイプ：',
      preference: '座席の希望：',
      confirmSelect: '選択を確認',
      noTrain: '列車が選択されていません',
      selectTrainFirst: '戻って列車を選択してください。'
    },
    submitted: {
      title: '予約を送信しました',
      thanks: 'ご予約ありがとうございます。ホームで発券結果をご確認ください',
      ticketName: '小田急ロマンスカー',
      route: '出発・到着：',
      travelDate: '利用日：',
      ticketCount: '予約数：',
      trainType: '車種：',
      seatClass: '座席タイプ：',
      preference: '座席の希望：',
      backHome: 'ホームに戻る'
    },
    notFound: {
      title: 'ページが見つかりません',
      message: 'URLをご確認のうえ、もう一度お試しください。'
    }
  }
};
